// extracted by mini-css-extract-plugin
export default {"contacts":"contacts_contacts__zf42g","whatsapp":"contacts_whatsapp__JMe1E"};